import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/morning.jpg";
import "../Pages/OurHistory.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function MonitoringEvaluation() {
  return (
    <div className="ne-page">
      <SEO
        title="Monitoring and Evaluation"
        description="CIRCODU's Monitoring and Evaluation services provide comprehensive tracking and analysis of environmental impact, technology performance, and project outcomes to ensure sustainable development and meaningful change."
        keywords="monitoring, evaluation, environmental impact, technology performance, project outcomes, sustainable development, CIRCODU, monitoring services Uganda, evaluation services Uganda"
        url="/our-services/monitoring-and-evaluation"
        type="website"
      />

      {/* Hero */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Monitoring and Evaluation</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Our Services</Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Monitoring and Evaluation
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="section border-bottom">
        <div className="container border-top">
          <div className="row">
            <div className="col-md-12 mt-2">
              {/* Intro */}
              <h5 style={{ color: "#008250", fontSize: "16px" }}>
                <b>Monitoring and Evaluation</b>
              </h5>
              <p className="texty">
                Since its very inception, CIRCODU has been at the forefront of
                environmental monitoring and the promotion of cleaner, smarter
                technologies. We believe that meaningful change can only be
                sustained when it is rigorously tracked, and that's exactly what
                we do.
              </p>

              {/* Indoor Air Pollution Surveillance */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>🖼️ Indoor Air Pollution Surveillance</b>
              </h5>
              <p className="texty">
                Long before clean cooking became a global conversation, CIRCODU
                was already in the field. We have dedicated years to monitoring
                indoor air pollution levels and championing eco-friendly
                technologies that protect families where they live. Our focus on
                improving the performance of wood and charcoal cookstoves across
                both households and institutions has directly contributed to
                reducing harmful emissions and cutting unnecessary fuel
                consumption.
              </p>

              {/* Technology & Project Monitoring */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>⚙️ Technology and Project Monitoring</b>
              </h5>
              <p className="texty">
                Our monitoring work spans a growing portfolio of critical
                initiatives, including:
              </p>
              <ul className="texty">
                <li className="mt-2">
                  <b>Cookstove Improvement Projects</b> — Tracking performance,
                  adoption, and real-world impact at the household and
                  institutional level
                </li>
                <li className="mt-2">
                  <b>Biogas Systems</b> — Monitoring the efficiency and
                  effectiveness of biogas infrastructure to ensure communities
                  get maximum benefit
                </li>
                <li className="mt-2">
                  <b>Water-Related Carbon Projects</b> — Overseeing carbon
                  initiatives in Uganda that align with global environmental
                  standards
                </li>
              </ul>

              {/* Independent Verification */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>✅ Independent Verification</b>
              </h5>
              <p className="texty">
                Integrity is everything in monitoring and evaluation. CIRCODU
                proudly serves as an{" "}
                <b>independent verification and outcomes monitoring partner</b>{" "}
                for the{" "}
                <b>Uganda Clean Cooking Supply Chain Expansion Project,</b>{" "}
                providing the objective, credible assessments that donors,
                governments, and implementing partners rely on.
              </p>

              {/* The Bigger Picture */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>📋 The Bigger Picture</b>
              </h5>
              <p className="texty">
                Every data point we collect, every stove we test, and every
                project we evaluate feeds into one overarching goal:{" "}
                <b>accelerating the adoption of clean cooking technologies</b>{" "}
                that reduce harmful emissions and lead to measurably better
                health outcomes for Ugandan communities.
              </p>

              <hr />

              {/* Closing statement */}
              <p className="texty">
                <i>
                  At CIRCODU, monitoring is not just a service — it is our
                  commitment to accountability, transparency, and lasting
                  impact.
                </i>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default MonitoringEvaluation;
